// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Hr-z","badgeLink":"Ir-z","category":"Jr-z"};